import { Card, Col, Row } from "react-bootstrap";
import { ButtonGroup, Collapse, IconButton, Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { useState } from "react";
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const CategoryCard = ({ id, label, children, onEdit, onDelete, isChild = false }) => {
    const [open, setOpen] = useState(false);

    const handleEdit = () => {
        onEdit && onEdit(id)
    }

    const handleDelete = () => {
        onDelete && onDelete(id)
    }

    const handleCollapse = () => {
        setOpen(!open)
    }

    return (
        <Col className={isChild ? '' : 'mb-3'}>
            <Card style={{ width: isChild ? 380 : 500, height: 50, padding: 0 }}
                className='shadow-sm bg-white rounded m-1'>
                <Row>

                    {
                        children && !isChild && (
                            <Col className='col-auto'>
                                <IconButton onClick={handleCollapse}>
                                    {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                                </IconButton>
                            </Col>
                        )
                    }

                    <Col className=' ml-3' style={{ marginTop: 14 }}>
                        {label}
                    </Col>
                    <Col className='ml-auto col-auto' hidden={isChild}>
                        <ButtonGroup>
                            <Button variant="text" onClick={handleEdit} startIcon={<EditIcon />} />
                            <Button variant="text" onClick={handleDelete} startIcon={ <DeleteIcon />} />
                        </ButtonGroup>
                    </Col>
                </Row>
            </Card>

            <Collapse in={open}  >
                <Row className='ml-4' >
                    {
                        children && children.map((item, id) => (
                            <Row key={id}>
                                <CategoryCard {...item} isChild />
                            </Row>
                        ))
                    }
                </Row>
            </Collapse>


        </Col>
    )
}

export default CategoryCard;
